<template>
  <span>
    <a-button @click="showModal">列表数据筛选</a-button>

    <!-- 控制表格列弹窗 -->
    <a-modal v-model:visible="isModalVisible" title="列表数据筛选" :maskClosable="false" :closable="true" :keyboard="false">
      <template slot="footer">
        <a-button key="submit" @click="handlerSubmit">确定</a-button>
        <a-button key="back" @click="handlerClose">关闭</a-button>
      </template>
      <div class="columns-list">
        <a-row>
          <a-col :span="24">
            <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">全选</a-checkbox>
            <a-button type="link" @click="onReverseSelection">反选</a-button>
          </a-col>
          <a-col :span="24" v-for="(item, index) in localColumns" :key="index">
            <a-checkbox :checked="item.show || item.show == undefined" :value="item.title" @change="val=>{handleColumnChange(val, index)}" :disabled="item.cantCheck || item.title === '操作'">{{item.title || item.title1}}</a-checkbox>
          </a-col>
          <a-col :span="24">
            <div style="color: red; margin-top: 10px;">*展示项最少需选择{{minNum}}项</div>
          </a-col>
        </a-row>
      </div>
    </a-modal>
  </span>
</template>

<script>
  export default {
    props: {
      value: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        isModalVisible: false,
        localColumns: [...this.value],
        minCheckedNum: 1, // 最少保留n个
      }
    },
    watch: {
      value(newVal) {
        this.localColumns = [...newVal];
      }
    },
    computed: {
      minNum() {
        return this.minCheckedNum > this.localColumns.length ? this.localColumns.length : this.minCheckedNum;
      },
      indeterminate() {
        let checkNum = 0;
        let list = this.localColumns.map(item => {
          if(item.show || item.show == undefined) {
            checkNum += 1;
          }
        });
        return this.localColumns.length > 0 && checkNum > 0 && checkNum < this.localColumns.length;
      },
      checkAll() {
        let checkNum = 0;
        let list = this.localColumns.map(item => {
          if(item.show || item.show == undefined) {
            checkNum += 1;
          }
        });
        return this.localColumns.length > 0 && checkNum == this.localColumns.length;
      }
    },
    methods: {
      onReverseSelection() {
        let hasCheckedNum = 0;
        let list = this.localColumns.map((item, i) => {
          if(item.cantCheck || item.title === '操作') {
            item.show = true;
            hasCheckedNum += 1;
          } else {
            if(item.show || item.show == undefined) {
              item.show = false;
            } else {
              item.show = true;
              hasCheckedNum += 1;
            }
          }
          return item;
        });

        if(hasCheckedNum < this.minNum) {
          let lastNum = this.minNum - hasCheckedNum;
          for(let i = list.length - 1; i >= 0; i--) {
            let item = list[i];
            if(!item.show) {
              item.show = true;
              lastNum -= 1;
              if(lastNum <= 0) {
                break;
              }
            }
          }
          this.$message.error(`展示项最少需要选择${this.minNum}项`);
        }
        this.localColumns = [].concat(list);
      },
      onCheckAllChange(e) {
        let checked = e.target.checked;
        let hasCheckedNum = 0;
        let list = this.localColumns.map((item, i) => {
          if(!checked) {
            if(item.cantCheck || item.title === '操作') {
              item.show = true;
              hasCheckedNum += 1;
            } else {
              item.show = checked;
            }
          } else {
            item.show = checked;
          }
          return item;
        });

        if(!checked && hasCheckedNum < this.minNum) {
          let lastNum = this.minNum - hasCheckedNum;
          for(let i = list.length - 1; i >= 0; i--) {
            let item = list[i];
            if(!item.show) {
              item.show = true;
              lastNum -= 1;
              if(lastNum <= 0) {
                break;
              }
            }
          }
          this.$message.error(`展示项最少需要选择${this.minNum}项`);
        }
        this.localColumns = [].concat(list);
      },
      showModal() {
        this.isModalVisible = true;
      },
      handlerSubmit() {
        this.$emit('input', this.localColumns);
        this.isModalVisible = false;
      },
      handlerClose() {
        this.localColumns = [].concat(this.value);
        this.isModalVisible = false;
      },
      handleColumnChange(val, idx) {
        let checked = val.target.checked;
        this.localColumns[idx].show = checked;
        if(this.localColumns.filter(item=>{
          return item.show || item.show == undefined;
        }).length < this.minNum) {
          this.$message.error(`展示项最少需要选择${this.minNum}项`);
          this.localColumns[idx].show = true;
        } else {}
        this.localColumns = [].concat(this.localColumns);
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/TableColmnsBtn.vue